import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Ueber uns</h3>
            <p>
              Ihr vertrauenswerter Partner fuer Fahrradverleih und urbane
              Mobilitaet. Entdecken Sie die Stadt auf zwei Raedern mit unseren
              hochwertigen Fahrraeder.
            </p>
          </div>
          <div className="footer-section">
            <h3>Schnelllinks</h3>
            <ul className="footer-links">
              <li>
                <Link to="/">Startseite</Link>
              </li>
              <li>
                <Link to="/about">Ueber uns</Link>
              </li>
              <li>
                <Link to="/contact">Kontakt</Link>
              </li>
            </ul>
          </div>
          <div className="footer-section">
            <h3>Kontakt</h3>
            <p>Ederring 7</p>
            <p>01775 Starnberg, Deutschland</p>
            <p>Tel: +4990874455288</p>
            <p>Registrierungsnummer: 21550582</p>
            <p>
              Email:{" "}
              <a href="mailto:tulvod@hotmail.com">tulvod@hotmail.com</a>
            </p>
            <p>
              <a href="https://wa.me/4990874455288">WhatsApp</a>
            </p>
            <p>
              <a href="https://viber.me/4990874455288">Viber</a>
            </p>
          </div>
          <div className="footer-section">
            <h3>Folgen Sie uns</h3>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2026 Tulvod. Alle Rechte vorbehalten.</p>
          <div className="footer-legal">
            <Link to="/privacy-policy">Datenschutzerklaerung</Link>
            <Link to="/terms-conditions">Nutzungsbedingungen</Link>
            <Link to="/refund-policy">Rueckgaberichtlinie</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;